import { render, staticRenderFns } from "./SalesForecastInput.vue?vue&type=template&id=4d8f6ecf&scoped=true"
import script from "./SalesForecastInput.vue?vue&type=script&lang=js"
export * from "./SalesForecastInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f6ecf",
  null
  
)

export default component.exports